export const handleize = (string = '') =>
  string
    .replace(/[^a-zA-Z0-9\u00C0-\u017F]+/g, '-')
    .normalize('NFD')
    .replace(/[\u0300-\u036f]/g, '')
    .toLowerCase()
